<template>
  <span class="h-row">
    <span
      v-for="i in indicators"
      :key="i[0]"
      :title="i[0]"
      class="hb-flag"
      :class="i[2] ? i[1] : ''"
    />
  </span>
</template>

<script>
import _ from 'lodash'

function hasGps(hb) {
  let flag = _.get(hb, 'summary.hasGps')
  if (flag == false) return false

  if (
    hb.latitude == 0 ||
    hb.longitude == 0 ||
    hb.latitude >= 90 ||
    hb.latitude <= -90 ||
    hb.longitude <= -180 ||
    hb.longitude >= 180
  ) {
    return false
  }

  return true
}

function getIndicators(row) {
  let h = row.summary
  let result = [
    ['engineOn', 'blue', h.engineOn],
    ['hasSpeed', 'amber', h.hasSpeed],
    ['noGps', 'red', !hasGps(row)],
    ['speedFromGps', 'grey', h.speedFromGps],
    ['rpmFromAccel', 'purple', h.rpmFromAccel],
    ['dumpPointer', 'red', h.hasDumpedPointer],
    ['ptrCorrection', 'red', h.hasPointerCorrection],
    ['skipped', 'black', h.skipped],
    ['wifiId', 'green', _.get(h, 'variables.wifiId') != null],
    ['globalstar', 'pink', row.source == 0x01],
    ['shutdown', 'red', _.get(h, 'variables.shutdownReason') != null],
    ['drainedOut', 'green', h.drainedOut]
  ]

  return result
}

export default {
  props: {
    hb: {}
  },
  computed: {
    indicators() {
      return getIndicators(this.hb)
    }
  }
}
</script>

<style>
.hb-flag {
  flex-grow: 1;
  background-color: #ccc;
  height: 18px;
  /* width: 6px; */
  border-radius: 1px;
  margin: 0 1px;
}
</style>
